/*
  Cantos do rodapé (sections/footer.liquid): a faixa do topo do rodapé ganha a cor do que está
  logo acima dele (o fim da página), para parecer que o conteúdo termina com cantos arredondados.
  Lê a cor quando o rodapé aparece na tela, pulando elementos fixos (header, barra de compra).
*/
(function () {
  'use strict';

  if (window.haloRodapeCantos) return;
  window.haloRodapeCantos = true;

  // Cor de fundo do próprio elemento, se for sólida. Aceita rgb()/rgba() e color(srgb ... / a),
  // que é como o Safari descreve algumas cores.
  function solidColor(el) {
    var color = getComputedStyle(el).backgroundColor;
    if (!color || color === 'transparent') return '';
    var alpha = color.match(/rgba\([^)]*,\s*([\d.]+%?)\s*\)/) || color.match(/\/\s*([\d.]+%?)\s*\)/);
    if (alpha) {
      var value = parseFloat(alpha[1]);
      if (alpha[1].indexOf('%') > -1) value = value / 100;
      if (value <= 0.5) return '';
    }
    return color;
  }

  function isFixed(el) {
    for (var node = el; node && node !== document.body; node = node.parentElement) {
      var position = getComputedStyle(node).position;
      if (position === 'fixed' || position === 'sticky') return true;
    }
    return false;
  }

  function update(band) {
    var section = band.parentElement;
    var top = section.getBoundingClientRect().top;
    if (top < 2 || top > window.innerHeight) return;
    var stack = document.elementsFromPoint(Math.min(24, window.innerWidth / 2), top - 1);
    // A pilha vem do elemento mais à frente até o <html>: a primeira cor sólida de largura
    // inteira é o fundo que se vê (inclui camadas de fundo que não são pais do conteúdo).
    for (var i = 0; i < stack.length; i++) {
      var el = stack[i];
      if (section.contains(el) || isFixed(el)) continue;
      // Só fundos da largura da página (não cartões de produto, por exemplo).
      if (el.getBoundingClientRect().width < window.innerWidth * 0.6) continue;
      var color = solidColor(el);
      if (color) {
        section.style.setProperty('--halo-rodape-topo', color);
        return;
      }
    }
  }

  function init(root) {
    var bands = (root || document).querySelectorAll('[data-halo-rodape-cantos]');
    Array.prototype.forEach.call(bands, function (band) {
      if (band.haloObserver) return;
      band.haloObserver = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) update(band);
      });
      band.haloObserver.observe(band);
    });
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      Array.prototype.forEach.call(document.querySelectorAll('[data-halo-rodape-cantos]'), update);
    }, 200);
  });

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });

  init();
})();
